import { subject } from '@casl/ability';
import { useAbility } from '@casl/vue';
import { useAbilities } from '@/queries/auth/use-login';
import { useMe } from '@/queries/use-users';
import { useStationStore } from '@/stores/station.store';
import { computed, watch } from 'vue';

export const useCurrentStations = () => {
  const stationStore = useStationStore();
  const { data: user } = useMe();
  const ability = useAbility();
  const { data: abilityRules } = useAbilities();

  const canOperateStation = (stationId: string) =>
    ability.can('operateOn', subject('Station', { id: stationId }));

  watch(
    () => abilityRules.value,
    () => {
      const stationId = stationStore.currentStationId;
      if (!stationId || !abilityRules.value) return;
      if (canOperateStation(stationId)) return;
      stationStore.setCurrentStation(null);
    },
    { immediate: true },
  );

  return computed(() => {
    const stationId = stationStore.currentStationId;
    if (stationId) {
      if (!abilityRules.value) return undefined;
      if (canOperateStation(stationId)) return [stationId];
    }
    return user.value?.stations.map((station) => station.id);
  });
};
